import React, { useEffect } from "react";

const ProductReviewSchemaMarkup = ({ productData, reviews, averageRating }) => {
  useEffect(() => {
    if (!productData) return;

    const productUrl = `https://parishaudio.com/products/${productData.productURI}`;
    const reviewPageUrl = `https://parishaudio.com/reviews/${productData.productURI}`;
    const imageUrl = productData.images?.[0]?.URI
      ? `https://parishaudio.com${productData.images[0].URI}`
      : undefined;

    const schemaData = {
      "@context": "https://schema.org",
      "@type": "SoftwareApplication",
      name: productData.name,
      applicationCategory: "MultimediaApplication",
      operatingSystem: "Windows, macOS",
      description: productData.shortDescription,
      sku: productData.SKU,
      url: productUrl,
      publisher: {
        "@type": "Organization",
        name: "Parish Audio",
        url: "https://parishaudio.com"
      },
      brand: {
        "@type": "Brand",
        name: "Parish Audio"
      },
      image: imageUrl,
      offers: {
        "@type": "Offer",
        price: Number(productData.price || 0).toFixed(2),
        priceCurrency: "USD",
        availability: "https://schema.org/InStock",
        url: productUrl
      },
      aggregateRating:
        Number(productData.ratingCount) > 0
          ? {
              "@type": "AggregateRating",
              ratingValue: String(averageRating || productData.starRating || 0),
              reviewCount: String(productData.ratingCount)
            }
          : undefined,
      review:
        reviews && reviews.length > 0
          ? reviews.slice(0, 10).map((review) => ({
              "@type": "Review",
              author: {
                "@type": "Person",
                name: review.userName || "Anonymous"
              },
              datePublished: review.createdAt,
              reviewBody: review.comment,
              reviewRating: {
                "@type": "Rating",
                ratingValue: String(review.starRating),
                bestRating: "5",
                worstRating: "1"
              }
            }))
          : undefined,
      mainEntityOfPage: reviewPageUrl
    };

    const cleanedSchemaData = JSON.parse(JSON.stringify(schemaData));

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.innerHTML = JSON.stringify(cleanedSchemaData);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, [productData, reviews, averageRating]);

  return null;
};

export default ProductReviewSchemaMarkup;